import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const ChevronLeft = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props} aria-hidden="true">
            <path
                id="arrow"
                d="M9.79452 11.5643L17 4.27139L15.6027 2.85718L7 11.5643L15.6027 20.2714L17 18.8572L9.79452 11.5643Z"
                fill="currentColor"
            />
        </Icon>
    )
}

ChevronLeft.propTypes = {onClick: PropTypes.func}

export default ChevronLeft
